import React, { useState } from "react";
import toast from "react-hot-toast";
import { useSelector } from "react-redux";

import api from "@/services/api";
import useStore from "@/services/store";
import Modal from "@/components/modal";

// A deal is a project at stage "prospection", so creating one here is the same POST the Projects
// page makes, with the sales defaults pre-set. The API stamps the creator as
// sales_business_provider_*, which is what "who brought the deal in" means on the board.
export default function NewDeal({ onCreated }) {
  const [open, setOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const [values, setValues] = useState({ name: "", description: "" });

  const organisation = useStore((state) => state.organisation);
  const { businessUnit } = useSelector((state) => state.Auth);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const body = { ...values, status: "active", stage: "prospection", sales_stage: "new" };
      if (organisation && organisation._id !== "ALL") {
        body.organisation_id = organisation._id;
        body.organisation_name = organisation.name;
      }
      if (businessUnit && businessUnit._id !== "ALL") {
        body.business_unit_id = businessUnit._id;
        body.business_unit_name = businessUnit.name;
      }

      const { ok, data } = await api.post("/project", body);
      if (!ok) return toast.error("Failed to create the deal");

      toast.success("Deal created");
      setValues({ name: "", description: "" });
      setOpen(false);
      onCreated(data);
    } catch (error) {
      console.error(error);
      toast.error("Failed to create the deal");
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <button type="button" onClick={() => setOpen(true)} className="px-3 py-1.5 text-sm font-medium text-white bg-blue-600 rounded-md hover:bg-blue-700">
        New deal
      </button>

      <Modal isOpen={open} className="max-w-xl w-full rounded-lg" onClose={() => setOpen(false)}>
        <form onSubmit={submit} className="p-6 space-y-4 bg-white rounded-lg">
          <div>
            <h2 className="text-lg font-semibold text-gray-900">New deal</h2>
            <p className="text-sm text-gray-500">Lands in New on the board, with you as the source. Owners and next action are set on the deal itself.</p>
          </div>

          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">Account / opportunity</label>
            <input
              className="input w-full"
              value={values.name}
              onChange={(e) => setValues({ ...values, name: e.target.value })}
              placeholder="e.g. Tôlerie Rémond — Validation de plans 3D"
              required
              autoFocus
            />
          </div>

          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">What is it</label>
            <textarea
              className="input w-full min-h-[90px]"
              value={values.description}
              onChange={(e) => setValues({ ...values, description: e.target.value })}
              placeholder="What they need, who the contact is, where it came from."
              rows={3}
            />
          </div>

          <div className="flex justify-end gap-2 pt-2">
            <button type="button" onClick={() => setOpen(false)} className="px-3 py-1.5 text-sm font-medium text-gray-700 bg-white border border-gray-300 rounded-md hover:bg-gray-50">
              Cancel
            </button>
            <button
              type="submit"
              disabled={loading || !values.name}
              className="px-3 py-1.5 text-sm font-medium text-white bg-blue-600 rounded-md hover:bg-blue-700 disabled:opacity-50">
              {loading ? "Creating…" : "Create deal"}
            </button>
          </div>
        </form>
      </Modal>
    </>
  );
}
